export default {
    _map: null,
    _coordinates: null,
    init() {
        this._map = document.querySelector('[data-product-map]');
        if (!this._map) {
            return;
        }

        const coords = JSON.parse(this._map.getAttribute('data-product-map'));
        if (coords.lat && coords.lng) {
            this._coordinates = {lat: parseFloat(coords.lat), lng: parseFloat(coords.lng)};
        }

        if (google && this._coordinates) {
            this._generateMap();
        }
    },
    reload(){
		this.init();
	},
    _generateMap() {
        const options = {
            zoom             : 12,
            center           : this._coordinates,
            mapTypeControl   : false,
            streetViewControl: false,
            fullscreenControl: false,
            scrollwheel      : false
        }
        const map    = new google.maps.Map(this._map, options);
        const marker = new google.maps.Marker({
            position: this._coordinates,
            map: map
        });

        marker.addListener('click', () => {
            const to_google_link = this._getGoogleMapsLink();
            if (to_google_link) {
                window.open(to_google_link, "_blank");
            }
        });

        /*

        ----- Make info windows on marker click: -----

        const contentString = `
            <div id="content">
                <-- Put html here -->
            </div>
        `;
        const infoWindow = new google.maps.InfoWindow({
            content: contentString
        });

        marker.addListener('click', () => {
            infoWindow.open(map, marker);
        });

        */
    },
    _getGoogleMapsLink()
    {
        if (typeof this._coordinates === "object") {
            const { lat, lng } = this._coordinates;
            return `https://www.google.com/maps/dir/?api=1&origin=&destination=${lat},${lng}`;
        } else {
            return null;
        }

    }
}